module.exports = __webpack_public_path__ + "static/media/horarios.1eaab2de.svg";